import { ReactElement } from 'react'
import { Flex, Text, ThemeUIStyleObject } from 'theme-ui'

export default function Tag({
  title,
  textColour = 'white50',
  padding = '0.6rem 2rem',
  sxx,
}: {
  title: string
  textColour?: string
  padding?: string
  sxx?: ThemeUIStyleObject
}): ReactElement {
  return (
    <Flex sx={{ justifyContent: 'center', width: '100%', ...sxx }}>
      <Flex
        sx={{
          padding,
          background: `linear-gradient(180deg, rgba(255, 255, 255, 0.01) 0%, rgba(255, 255, 255, 0.10) 49.67%, rgba(255, 255, 255, 0.01) 50%, rgba(255, 255, 255, 0.10) 100%)`,
          borderRadius: '4.6rem',
          flexShrink: 0,
          boxShadow: `0px 2px 0px 0px #000`,
          border: ({ colors }) => `2px solid ${colors?.white10}`,
          backgroundClip: 'padding-box',
        }}
      >
        <Text
          variant="text.heading3"
          sx={{
            color: textColour,
            textAlign: 'center',
          }}
        >
          {title}
        </Text>
      </Flex>
    </Flex>
  )
}
